<script setup>
import { computed } from 'vue';
import NextCheckbox from 'dashboard/components-next/checkbox/Checkbox.vue';

const props = defineProps({
  isChecked: {
    type: Boolean,
    default: false,
  },
  value: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['update']);

const checked = computed({
  get: () => props.isChecked,
  set: value => emit('update', props.value, value),
});
</script>

<template>
  <NextCheckbox v-model="checked" />
</template>
